import { createSelector } from 'reselect'
import { RootState } from '../reducers'

const getConcurrentRequestsCount = ({ http }: RootState) => http.concurrentRequestsCount

export const isLoading = createSelector([getConcurrentRequestsCount], (concurrentRequestsCount) => {
  return concurrentRequestsCount > 0
})
